var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "p-2 mt-1" },
      [
        _c("validation-observer", { ref: "docForm" }, [
          _c("div", { staticClass: "row py-4 px-5" }, [
            _c("div", { staticClass: "col-12 mb-3" }, [
              _c("em", { staticClass: "fas fa-file-upload text-orange mr-2" }),
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v("Anejar Carta Firmada")
              ])
            ]),
            _c("div", { staticClass: "col-12 mb-4 bg-white p-3 rounded" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-lg-4" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Tipo de Documento: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-normal color-black font-16" },
                    [_vm._v(" " + _vm._s(_vm.title) + " Firmada ")]
                  )
                ]),
                _c("div", { staticClass: "col-12 col-lg-4" }, [
                  _c("div", { staticClass: "color-secondary-6 font-14" }, [
                    _vm._v(" Archivo: ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "font-weight-normal color-black font-16" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("empty")(_vm.model.signatureFile?.name)
                          ) +
                          " "
                      )
                    ]
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-lg-4 d-flex justify-content-end align-items-center"
                  },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-file-input", {
                                ref: "fileUpload",
                                staticClass: "mt-4 pt-1",
                                attrs: {
                                  accept: _vm.allowedFiles,
                                  "custom-error-msg":
                                    "Favor seleccionar un documento.",
                                  "display-style": "normal",
                                  error: errors[0],
                                  label: "",
                                  "label-position": "left",
                                  "max-size": 100,
                                  "on-download": () => {},
                                  required: ""
                                },
                                model: {
                                  value: _vm.model.signatureFile,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "signatureFile", $$v)
                                  },
                                  expression: "model.signatureFile"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ])
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-12 d-flex justify-content-end align-items-center"
              },
              [
                _c("action-button", {
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger mr-3 px-3"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                }),
                _c("action-button", {
                  attrs: {
                    i: "fas fa-save",
                    text: "Guardar",
                    variant: "success px-3"
                  },
                  on: { click: _vm.save }
                })
              ],
              1
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }